import store from '@/store'
import { format, parseISO } from 'date-fns'
import { hmError } from '@/libs/toastification'
import hmStorage from '@core/utils/hm_storage'
import api from './axios'

// eslint-disable-next-line import/prefer-default-export
export async function reload() {
  console.info('reload')
  const hostmatic = await fetch('/hostmatic.json').then(res => res.json()).then(result => result)
  api.defaults.baseURL = hostmatic.backend_url
  return api.post('/api/matomo/get_all_sites', {
    startDate: format(store.state.app.range.startDate, 'yyyy-MM-dd'),
    endDate: format(store.state.app.range.endDate, 'yyyy-MM-dd'),
    period: store.state.app.period
  }).then(r => {
    if (r.data.code !== 'Ok') return hmError('Error reading data')
    const allSites = []
    if (r.data.allSites.length > 0) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const s in r.data.sites) {
        allSites.push(r.data.sites[s])
      }
    }
    // hmStorage.remove('idsite')
    let idsite = hmStorage.getLocalItem('idsite')
    console.log(idsite)
    if (!idsite && allSites.length > 0) {
      idsite = allSites[0].idsite
      hmStorage.setLocalItem('idsite', idsite)
    }
    const period = hmStorage.getLocalItem('period') || 'day'
    hmStorage.setLocalItem('period', period)
    let range = hmStorage.getLocalItem('range')
    if (range) {
      range.startDate = parseISO(range.startDate)
      range.endDate = parseISO(range.endDate)
    } else {
      range = {
        startDate: new Date(),
        endDate: new Date()
      }
    }
    hmStorage.setLocalItem('range', range)
    store.commit('app/SET_APP_STATE', { allSites, validDates: r.data.validDates, idsite, period, range })
  })
}
